import {Component, OnInit, Input, NO_ERRORS_SCHEMA, NgModule, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {CityService} from "../../../../services/city.service";
import {CitiesShowComponent} from "../../cities/cities-show/cities-show.component";
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {RecordDataComponent} from "../../../../components/record-data";
import {PermissionService} from "../permission.service";
import {Permission} from "../permission";
import {UsersShowComponent} from "../../users/users-show/users-show.component";
import {YearsShowComponent} from "../../years/years-show/years-show.component";

@NgModule ({
  imports:[CommonModule,FormsModule,DropdownModule,MessagesModule,MessageModule,
    ReactiveFormsModule,ConfirmDialogModule,TranslateModule.forChild()
  ],
  declarations:[
    PermissionsShowComponent
  ],
  entryComponents: [
    PermissionsShowComponent
  ],
  exports:[],
  providers: [SharedService,PermissionService,CityService,MessageService,ConfirmationService],
  schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-permissions-show',
    templateUrl: './permissions-show.component.html',
    styleUrls: ['./permissions-show.component.scss'],
    providers: [PermissionService, CityService, ConfirmationService, MessageService]
})

export class PermissionsShowComponent implements OnInit, AfterViewInit  {
  id: string;
  permission: Permission;
  applog: AppLogComponent;
  cities: any[] = [];
  screens: any[] = [];
  options : any[] = [];
  optionsMap: any[] = [];
  optionsMap2: any[] = [];
  optionsChecked : any[] = [];
  Selected_users: any[] = [];
  @Input() refShow;
  @Input() scrId;
  modalRef: NgbModalRef;
  parent:any;

  @Input() delPermissionId;
  @Input() oldData;
  @Input() newData;

  statusVal = [{'val':1,'title':'Active'},{'val':0,'title':'Inactive'}];

  form: FormGroup;
  private sub: any;
  msgs: Message[] = [];

  private _saveButton: any;
  private _deleteButton: any;
  private _newButton: any;
  private _printButton: any;
  private _searchButton: any;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private sharedservice: SharedService,
              private cityService: CityService,
              private permissionService: PermissionService,
              public activeModal: NgbActiveModal,
              public translate: TranslateService,
              private confirmationService: ConfirmationService,
              private modalService: NgbModal,
              private messageService: MessageService) {
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if(userdata && userdata.lang) {
      this.translate.use(userdata.lang);
    }

    this.sharedservice.setTitle(this.route.snapshot.data.title);
    this.sharedservice.setButtons([
      { label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton' },
      { label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton' },
      // { label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton' },
      { label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton' },
      { label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton' }
    ]);
    this.sharedservice.setModelName('');
    this.refShow = this.sharedservice.getItemShow();

    }

    showParent() {
      if(this.parent[0]) {
          const options: NgbModalOptions = {

              beforeDismiss: () => {
                  console.log("before dismiss");
                  //
                  return true;
              }
          };
          this.modalRef = this.modalService.open(UsersShowComponent, options);
          this.modalRef.componentInstance.scrId = this.parent[0];
          console.log(this.parent[0]);
          this.modalRef.result.then(() => {
              this.activeModal.dismiss('done');
          }, () => {
              console.log('Backdrop click')
          });
      }
    }

    ngAfterViewInit() {
        if(!this.scrId) {

            this._saveButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');


            if (this._saveButton) {
                this._saveButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/permissions/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deletePermission(this.permission);
                });
            }
            if (this._newButton) {
                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/permissions']);
                });
            }
            this._searchButton.onclick = ((e: any) => {
                e.preventDefault();
                this.router.navigate(['/permissions/search']);
            });
        }
    }

    ngOnInit() {
        this.permissionService.getAll_screens().subscribe(
            optionsMap => {
                this.optionsMap = optionsMap;

                this.screens = optionsMap.screens;

            });


        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
            display_name: new FormControl({value: '', disabled: true}),
            status: new FormControl({value: '', disabled: true})

        });

        if (this.id) {

      this.activeModal.dismiss('');

      this.oldData = false;
      this.newData = false;
      if(this.oldData && this.newData) {
        this.permission = this.newData;
        this.form.patchValue({
          id: this.newData.id,
          display_name: this.newData.display_name,
          description: this.newData.description,
          status: this.newData.status
        });
      }

            this.delPermissionId = false;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }


            this.permissionService.getById(this.id).subscribe(
                permission => {
                    this.id = permission.id;
                    this.permission = permission;
                    // this.parent = permission.name;
                    this.form.patchValue({
                        id: permission.id,
                        display_name: permission.display_name,
                        description: permission.description,
                        status: permission.status
                    });

                    this.options = permission.description;
                    this.Selected_users = permission.alluser2;
                    this.parent = this.Selected_users.map(value => value.value);

                   // this.parent = this.Selected_users.value;
                    //this.options = JSON.parse(permission.description);

                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.scrId) {

            this.oldData = false;
            this.newData = false;

            this.delPermissionId = false;



            this.permissionService.getById(this.scrId).subscribe(
                permission => {
                    this.id = permission.id;
                    this.permission = permission;
                    this.form.patchValue({
                        id: permission.id,
                        display_name: permission.display_name,
                        description: permission.description,
                        status: permission.status
                    });

                    this.options = permission.description;
                    this.Selected_users = permission.alluser2;
                    this.parent = this.Selected_users.map(value => value.value);



                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.delPermissionId) {
            this.oldData = false;
            this.newData = false;
            this.permissionService.getTrashedById(this.delPermissionId).subscribe(
                permission => {
                    this.id = permission.id;
                    this.permission = permission;
                    this.form.patchValue({
                        id: permission.id,
                        display_name: permission.display_name,
                        description: permission.description,
                        status: permission.status,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

    if(this.oldData && this.newData) {
      this.permission = this.newData;
      this.form.patchValue({
        id: this.newData.id,
        display_name: this.newData.display_name,
        description: this.newData.description,
        status: this.newData.status
      });
    }


  }

  deletePermission(permission: Permission) {
    this.confirmationService.confirm({
      header: this.translate.instant('Confirm Delete'),
      message: this.translate.instant('Are you sure of delete ?'),
      icon: 'fa fa-trash',
      accept: () => {
        if (permission) {
          this.permissionService.delete(permission.id).subscribe(
            res => {
              if(res.result){
                this.msgs = [];
                this.msgs.push({severity: 'success', summary: '', detail: this.translate.instant(res.message)});
                  setTimeout(()=> {
                      this.router.navigate(['/permissions/list']);
                  },1000);
                  localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                  window.scroll(0,0);
              }else{
                this.msgs = [];
                this.msgs.push({severity: 'error', summary: '', detail: this.translate.instant(res.message)});
                    // this.router.navigate(['/permissions']);



              }


            }
          );
        }
      }
    });

  }

    recoverEdit(permission: Permission) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (permission) {
                    this.permissionService.update(permission).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/permissions/show', permission.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delPermissionId) {
                    this.permissionService.restoreTrashedById(this.delPermissionId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/permissions/list']);
                        }
                    );
                }
            }
        });
    }


    checkAll(name: string, option: any[], ev) {
        if (ev.target.checked) {
            for (let screen of option) {
                let idx = this.options.indexOf(screen.value);
                if (idx == -1) {
                    this.options.push(screen.value);
                }
            }
            document.getElementById(name).style.backgroundColor = "green";
        } else {
            for (let screen of option) {
                let idx = this.options.indexOf(screen.value);
                if (idx !== -1) {
                    this.options.splice(idx, 1);
                }
                //delete this.options[idx];
            }
            document.getElementById(name).style.backgroundColor = "red";
        }

        //this.options = option
    }

    checkAllsys(name: string, option: any[], ev) {

        if (ev.target.checked) {
            for (let x in option) {
                for (let screen of option[x].description) {
                    let idx = this.options.indexOf(screen.value);
                    if (idx == -1) {
                        this.options.push(screen.value);
                    }
                }
            }
            document.getElementById(name).style.backgroundColor = "green";
        } else {
            for (let x in option) {
                for (let screen of option[x].description) {
                    let idx = this.options.indexOf(screen.value);
                    if (idx !== -1) {
                        this.options.splice(idx, 1);
                    }
                    //delete this.options[idx];
                }
            }
            document.getElementById(name).style.backgroundColor = "red";
        }

    }

    check_color(optionsts: any[]) {
        let count = 0;
        let size = optionsts.length;

        for (let screen of optionsts) {

            if (this.options.indexOf(screen.value) > -1) {
                count++;
            }
        }
        if (count == 0) {
            return 0;
        }
        if (size > count) {
            return 1;
        }
        if (size == count) {
            return 2;
        }

    }

    check_colorsys(optionsts: any[]) {
        let count = 0;
        let size = 0;
        let arraytemp: any[] = [];
        for (let x in optionsts) {
            for (let screen of optionsts[x].description) {
                size++;
                arraytemp.push(screen)
            }
        }


        for (let screen of arraytemp) {

            if (this.options.indexOf(screen.value) > -1) {
                count++;
            }
        }
        if (count == 0) {
            return 0;
        }
        if (size > count) {
            return 1;
        }
        if (size == count) {
            return 2;
        }

    }

    checkingList(optionsts: any[]) {
        let count = 0;
        let size = optionsts.length;

        for (let screen of optionsts) {

            if (this.options.indexOf(screen.value) > -1) {
                count++;
            }
        }
        if (size == count) {
            return true;
        } else {
            return false;
        }

    }

    checkingListsys(optionsts: any[]) {
        let count = 0;
        let size = optionsts.length;

        for (let x in optionsts) {
            for (let screen of optionsts[x].description) {

                if (this.options.indexOf(screen.value) > -1) {
                    count++;
                }
            }
        }
        if (size == count) {
            return true;
        } else {
            return false;
        }

    }

  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
        modalRef.componentInstance.refShow = PermissionsShowComponent;
      modalRef.componentInstance.rowId = row_id;
    }
  }
  recordData() {
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        // this.changePicUrl();

        return true;
      }
    };
    JSON.parse(localStorage.getItem('filter'));

    const modalRef = this.modalService.open(RecordDataComponent, options);
    modalRef.componentInstance.refRec = this.permission;
    modalRef.componentInstance.rowId = '';

  }

}



// WEBPACK FOOTER //
// ./src/app/views/setting/permissions/permissions-show/permissions-show.component.ts